var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "default-page-paddings" }, [
    _c(
      "div",
      { staticClass: "container container-medium" },
      [
        _c("Heading", {
          attrs: {
            title: "Cookies",
            routeName: "vignette",
            alignment: "text-left",
          },
        }),
        _vm._m(0),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "default-content reading" }, [
      _c("p", [
        _vm._v(
          "Prin navigarea pe site-urile din domeniul e-rovinieta.ro, prin intermediul browserului, în calculatorul dumneavoastră pot fi stocate mici fişiere cu date, cunoscute sub numele de cookie-uri. "
        ),
        _c("br"),
        _vm._v(
          " În anumite situaţii, vizitatorii site-urilor din domeniul E-rovinieta.ro pot sa regăsească următoarele categorii de cookie-uri:"
        ),
      ]),
      _c("ul", [
        _c("li", [
          _c("strong", [_vm._v("cookie-uri de sesiune")]),
          _vm._v(
            " – folosite pentru identificarea unui dispozitiv în mod unic, în vederea efectuării de statistici privind numărul de vizitatori"
          ),
        ]),
      ]),
      _c("p", [
        _vm._v(
          "- durata de viaţă a acestor cookie-uri este până la închiderea browserului de internet;"
        ),
      ]),
      _c("p", [
        _vm._v(
          "- nu stochează informaţii care să identifice o persoană sau date cu caracter personal;"
        ),
      ]),
      _c("p", [
        _vm._v(
          "- nu conţin viruşi, cod maliţios şi nu pot extrage date din dispozitivul vizitatorului."
        ),
      ]),
      _c("ul", [
        _c("li", [
          _c("strong", [_vm._v("cookie-uri ale unor terţi")]),
          _vm._v(" – Google Analytics"),
        ]),
      ]),
      _c("p", [
        _vm._v(
          "- aceste cookie-uri nu sunt gestionate sau controlate la nivelul site-urilor web din domeniul e-rovinieta.ro, politica de confidenţialitate specifică acestora fiind disponibilă la"
        ),
        _c(
          "a",
          {
            staticClass: "custom-link",
            attrs: { href: "https://www.google.com/intl/ro/policies/privacy/" },
          },
          [_vm._v(" această adresă")]
        ),
        _vm._v(" ."),
      ]),
      _c("p", [
        _vm._v(
          "Informaţiile prezentate în continuare au ca scop informarea vizitatorilor cu privire la cookie-uri. Vă rugăm citiţi cu atenţie informaţiile care urmează:"
        ),
      ]),
      _c("p", [
        _vm._v(
          'Un "Internet Cookie" (termen cunoscut şi ca "browser cookie" sau "HTTP cookie" sau pur şi simplu "cookie" ) este un fişier de mici dimensiuni, format din litere şi numere, care va fi stocat pe computerul, terminalul mobil sau alte echipamente ale unui utilizator de pe care se accesează Internetul.'
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          ' Cookie-ul este instalat prin solicitarea emisă de către un web-server unui browser (ex: Internet Explorer, Chrome) şi este complet "pasiv" (nu conţine programe software, viruşi sau spyware şi nu poate accesa informaţiile de pe hard drive-ul utilizatorului).'
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          " Un cookie este format din 2 parţi: numele şi conţinutul sau valoarea cookie-ului. Mai mult, durata de existenţă a unui cookie este determinată, tehnic, doar web-serverul care a trimis cookie-ul îl poate accesa din nou în momentul în care un utilizator se întoarce pe website-ul asociat web-serverului respectiv."
        ),
      ]),
      _c("p", [_c("strong", [_vm._v("Cookie-urile se clasifică în:")])]),
      _c("ul", [
        _c("li", [
          _c("strong", [_vm._v("Cookie-uri de sesiune")]),
          _vm._v(" ("),
          _c("strong", [_vm._v("session cookies")]),
          _vm._v(
            ") - acestea sunt stocate temporar în arhiva browserului care le memorează până în momentul în care este închis."
          ),
        ]),
        _c("li", [
          _c("strong", [_vm._v("Cookie-uri persistente")]),
          _vm._v(
            ' - acestea sunt stocate, în funcţie de durata stabilită de către emitent, pe hard-drive-ul unui computer sau echipament. Cookie-urile persistente le includ şi pe cele plasate de un alt website decât cel pe care vizitatorul îl accesează la momentul respectiv - cunoscute sub numele de "'
          ),
          _c("strong", [_vm._v("third party cookies")]),
          _vm._v(
            '"(cookie-uri plasate de către terţi). Acestea pot fi folosite în mod anonim pentru a memora interesele unui utilizator.'
          ),
        ]),
      ]),
      _c("p", [
        _c("strong", [_vm._v("Ce sunt cookie-urile plasate de terţi?")]),
      ]),
      _c("p", [
        _vm._v(
          'Anumite secţiuni de conţinut de pe unele site-uri pot fi furnizate prin intermediul unor terţe părţi/furnizori. Aceste terţe părţi pot plasa cookieuri prin intermediul unui alt site decât site-ul propriu şi de aici denumirea de "third party cookies" '
        ),
        _c("br"),
        _vm._v(
          " – cookie-uri plasate de un terţ şi nu de proprietarul website-ului respectiv. Acestea pot fi generate și de echipamente ce asigură securitatea și integritatea website-ului. Furnizorii terţi trebuie să respecte de asemenea legea în vigoare şi politicile de confidenţialitate ale deţinătorului site-ului."
        ),
      ]),
      _c("p", [
        _vm._v(
          "Companiile care generează aceste cookie-uri au propriile politici de confidenţialitate, iar acest site nu are acces pentru a citi sau scrie respectivele cookie-uri."
        ),
      ]),
      _c("p", [
        _c("strong", [_vm._v("Care este durata de viaţă a unui cookie?")]),
      ]),
      _c("p", [
        _vm._v(
          "Cookie-urile sunt administrate de web-servere. Durata de viaţă a unui cookie poate varia semnificativ, depinzând de scopul pentru care este plasat. Unele cookie-uri sunt folosite exclusiv pentru o singură sesiune (session cookies) şi nu mai sunt reţinute odată ce utilizatorul a părăsit browserul, în timp ce alte cookie-uri sunt reţinute şi refolosite de fiecare dată când utilizatorul revine pe acel website (“cookie-uri persistente”). Cu toate aceste, cookie-urile pot fi şterse de un utilizator în orice moment prin intermediul setărilor browserului."
        ),
      ]),
      _c("p", [
        _vm._v(
          "Pentru navigare pe site-ul web e-rovinieta.ro, durata de viață a unui cookie va fi de 30 de zile."
        ),
      ]),
      _c("p", [_c("strong", [_vm._v("Cum se folosesc cookie-urile?")])]),
      _c("p", [
        _vm._v(
          "Un cookie este un fragment mic de text creat în browser de site-ul web pe care îl accesaţi. Cu ajutorul acestuia, site-ul web reţine informaţii despre vizita dvs, în scopul de a efectua transmiterea unei comunicări printr-o rețea de comunicații electronice sau pentru analiza vizitatorilor pentru care softul de analytics furnizat de o terţă parte generează un cookie de analiză. Browserul dumneavoastră va informa softul de analiză daca aveţi acest cookie, iar dacă nu, acesta va genera unul. Acesta permite monitorizarea utilizatorilor unici care vizitează site-ul, precum şi frecvenţa cu care o fac. Atât timp cât nu sunteţi înregistrat pe site, acest gen de cookie nu poate fi folosit pentru a identifica persoanele fizice, fiind folosite doar în scop statistic."
        ),
      ]),
      _c("p", [
        _vm._v(
          "Informaţiile asociate cookie-urilor nu sunt utilizate pentru a stoca sau prelucra datele dumneavoastră personale."
        ),
        _c("br"),
        _vm._v(
          " Cookie-urile nu sunt folosite în alte scopuri decât cele descrise aici."
        ),
      ]),
      _c("p", [_c("strong", [_vm._v("Cum puteţi controla cookie-urile?")])]),
      _c("p", [
        _vm._v(
          "Activarea cookie-urilor nu este strict necesară pentru funcţionarea site-ului, dar vă poate îmbunătăţi experienţa de navigare. Puteţi şterge sau bloca cookie-urile însă, dacă faceţi acest lucru, s-ar putea ca anumite caracteristici ale site-ului să nu funcţioneze corespunzător."
        ),
      ]),
      _c("p", [
        _vm._v(
          "Toate browserele moderne oferă posibilitatea de a schimba setările cookie-urilor. Aceste setări se găsesc de regulă în secţiunea de “opţiuni” sau în meniul de “preferinţe” al browserului dumneavoastră."
        ),
      ]),
      _c("p", [
        _vm._v(
          "Pentru a înţelege aceste setări, următoarele link-uri pot fi folositoare, altfel puteţi folosi opţiunea “ajutor” a browserului pentru mai multe detalii:"
        ),
      ]),
      _c("ul", [
        _c("li", [
          _c(
            "a",
            {
              staticClass: "custom-link",
              attrs: { href: "https://support.microsoft.com/en-us/kb/196955" },
            },
            [_vm._v("Setări cookie-uri în Internet Explorer")]
          ),
        ]),
        _c("li", [
          _c(
            "a",
            {
              staticClass: "custom-link",
              attrs: {
                href: "https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies",
              },
            },
            [_vm._v("Setări cookie-uri în Mozilla Firefox ")]
          ),
          _vm._v("    "),
        ]),
        _c("li", [
          _c(
            "a",
            {
              staticClass: "custom-link",
              attrs: {
                href: "https://support.google.com/chrome/answer/95647?hl=en",
              },
            },
            [_vm._v("Setări cookie-uri în Google Chrome")]
          ),
        ]),
        _c("li", [
          _c(
            "a",
            {
              staticClass: "custom-link",
              attrs: {
                href: "https://support.apple.com/kb/PH5042?locale=en_US",
              },
            },
            [_vm._v("Setări cookie-uri în Safari ")]
          ),
          _vm._v("                   "),
        ]),
      ]),
      _c("p", [_vm._v(" ")]),
      _c("p", [_c("strong", [_vm._v("Google Analytics")])]),
      _c("p", [
        _vm._v(
          "Site-ul foloseste cookie-uri Google Analytics pentru a colecta informatii despre modul in care vizitatorii utilizeaza acest site si pentru a detecta posibile probleme de navigare. Google Analytics stocheaza informatii despre paginile vizitate, durata de navigare pe site, modalitatea prin care a fost accesat site-ul precum si sectiunile accesate din cadrul paginilor. Nu sunt stocate informatii personale, prin urmare, aceste informatii nu pot fi folsite pentru identificarea utilizatorului."
        ),
        _c("br"),
        _vm._v(
          " Site-ul foloseste Google Analytics pentru a putea urmari daca site-ul intruneste cerintele utilizatorilor si pentru a prioritiza imbunatatirea proceselor derulate. Google ofera mai multe informatii despre cookie-uri in pagina de politica a confidentialitatii si politica cookie-urilor. De asemenea, Google, pune la dispozitie un “add-on” ce ofera posibilitatea renuntarii la Google Analytics indifferent de paginile accesate."
        ),
      ]),
      _c("p", [
        _vm._v(
          "Daca doriti sa aflati mai multe informatii cu privire la modul in care Google foloseste si colecteaza aceste date , accesati link-ul "
        ),
        _c(
          "a",
          {
            staticClass: "custom-link",
            attrs: { href: "http://www.google.com/policies/privacy/" },
          },
          [_vm._v("privacy policy")]
        ),
        _vm._v("."),
      ]),
      _c("p", [_vm._v(" ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }